import { getPreselectedFilterValues } from "@/services/device.js";

export default {
  setPreselectedFilters({ commit }) {
    const values = getPreselectedFilterValues();
    commit("setPreselected", values);
  },
  setLastUsedFilters({ commit, state }, payload) {
    const values = {
      ...state.lastUsed,
      ...payload,
    };
    commit("setLastUsed", values);
  },
  clearLastUsedFilters({ commit }) {
    commit("setLastUsed", {});
  },
};
